import React from 'react';
import TabSectionHeader from '../Elements/TabSectionHeader';
import StackedCardCarousel from '../Elements/StackedCardCarousel';

import achievement1 from '../assets/Images/achievement1.png';
import achievement2 from '../assets/Images/achievement2.png';
import achievement3 from '../assets/Images/achievement3.png';
import achievement4 from '../assets/Images/achievement4.png';
import achievement5 from '../assets/Images/achievement5.png';

const ACHIEVEMENT_SLIDES = [
  { src: achievement1, alt: 'Achievement 1' },
  { src: achievement2, alt: 'Achievement 2' },
  { src: achievement3, alt: 'Achievement 3' },
  { src: achievement4, alt: 'Achievement 4' },
  { src: achievement5, alt: 'Achievement 5' },
];

const Achievements = () => (
  <div className="flex flex-col flex-1 min-h-0">
    <TabSectionHeader tabIndex={3} />
    <StackedCardCarousel slides={ACHIEVEMENT_SLIDES} />
  </div>
);

export default Achievements;
